import React, { useState, useEffect } from "react";
import "./App.css";

//importing components
import Home from "./components/Home";
import About from "./components/About";
import ProjectList from "./components/ProjectList";
import Footer from "./components/Footer";

function App() {
  const [loader, setLoader] = useState(true);

  //loading scroll animation
  var loadScript = function() {
    var tag = document.createElement("script");
    tag.async = false;
    var html = document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();

        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth"
        });
      });
    });
    tag.append(html);
    document.getElementsByTagName("body")[0].appendChild(tag);
  };

  useEffect(() => {
    setTimeout(function() {
      setLoader(false);
      loadScript();
    }, 3000);
  }, []);

  if (!loader) {
    return (
      <div className="App">
        <div className="AppContainer">
          <Home />
          <About />
          <ProjectList />
        </div>
        <Footer />
      </div>
    );
  } else {
    return (
      <div style={{ backgroundColor: "#f6f3ea" }}>
        <div>
          <div className="lds-dual-ring" />
        </div>
      </div>
    );
  }
}

export default App;
